import moment from "moment";
import momentTimezone from "moment-timezone";

export const getMomentDurationInMinutes = (
  duration_in_minutes: number | string
): moment.Duration => {
  return moment.duration(duration_in_minutes, "minutes");
};

export const getDurationInMinutes = (start: string, end: string | undefined) =>
  moment(end).diff(start, "minutes");

/**
 * Convert duration in minutes to the ISO 8601 duration format
 * e.g. 80 => PT1H20M
 *
 * @param {number | string} duration
 * @returns {string}
 */
export const convertDurationInMinutesToIso = (duration: number): string =>
  moment.duration(duration, "minutes").toISOString();

/**
 * Remove time offset from ISO 8601 dates
 * eg 2022-02-04T15:49:01+03:00 => 2022-02-04T15:49:01
 * eg 2022-02-04T15:49:01-03:00 => 2022-02-04T15:49:01
 *
 * @param {string} isoDate
 */
export const removeTimeOffset = (
  isoDate: string | undefined | null
): string => {
  if (!isoDate) {
    return "";
  }

  // We had to play with the groups and Lookahead because Lookbehind groups doesn't work on Safari and other Browsers
  const regex = /(?:(?!.*T.*))([+-])/;
  // @ts-expect-error TS2322 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
  return isoDate.split(regex)[0];
};

/**
 *
 * Convert from UTC (timezone offset 00:00) to local time
 *
 * @param time Example: 2024-02-27T11:20:00+00:00
 * @param timezone America/Toronto
 * @returns localtime 2024-02-27T06:20:00-05:00
 */
export function convertFromUTCToLocalTime(
  time: Date,
  timezone: string
): string {
  return momentTimezone(time).tz(timezone).format();
}
